import React from 'react';
import styled from 'styled-components';
import {
  AppContainer,
  MainContentContainer,
  BodyContainer,
} from '../../resources/styling/appStyle';
import { SideMenu } from '../../components/layouts/SideMenu';
import { Header } from '../../components/layouts/Header';
import '../../resources/styling/App.scss';
import EmailFilters from './EmailFilters';
import emailService from '../../services/api/emailStatus';
import EmailList from './EmailList';
import { toast } from 'react-toastify';
import Paging from './Paging';
import { sa, PageTitle, SectionStates } from '../../components/superAdminUi';

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sa.space.section};
  width: 100%;
`;

export const PaginationWrapper = styled.div`
  width: 100%;
  margin: auto;
  text-align: center;
  overflow: hidden;
  padding: 10px 0;
`;

export default function EmailLogs() {
  const [loading, setLoading] = React.useState(false);
  const [filters, setFilters] = React.useState(null);

  const doSearch = (newFilter) => {
    if (
      newFilter.surveyId === 0 &&
      newFilter.emailType === 0 &&
      newFilter.status === '' &&
      !newFilter.fromDate &&
      !newFilter.toDate
    ) {
      toast.error('Please select some filters');
      return;
    }
    var f = { ...filters, ...newFilter };
    setFilters(f);

    setLoading(true);
    emailService
      .search(f)
      .then((data) => {
        setFilters(data);
      })
      .catch((error) => console.error('Error fetching email data:', error))
      .finally(() => setLoading(false));
  };

  return (
    <AppContainer>
      <SideMenu />
      <BodyContainer>
        <Header />
        <MainContentContainer>
          <Stack>
            <PageTitle>Email Logs</PageTitle>
            <EmailFilters doSearch={doSearch} />
            {loading ? (
              <SectionStates loading />
            ) : (
              <>
                <EmailList emails={filters?.list} />
                <PaginationWrapper>
                  <Paging
                    pageCount={filters?.pageCount}
                    pageNo={filters?.pageNo}
                    pageSize={filters?.pageSize}
                    onPageChange={(page, pageSize) => {
                      if (page < 1 || page > filters?.pageCount) return;
                      else doSearch({ ...filters, pageNo: page, pageSize });
                    }}
                  />
                </PaginationWrapper>
              </>
            )}
          </Stack>
        </MainContentContainer>
      </BodyContainer>
    </AppContainer>
  );
}
